import { SalesAndResourcesSensorAcademyContent } from '../types/SalesAndResourcesSensorAcademyContent';

export function createSalesAndResourcesSensorAcademyContentPlaceholder(): SalesAndResourcesSensorAcademyContent {
    const emptyPlain = { kind: 'plainText' as const, key: '', content: '' };
    const emptyMulti = { kind: 'plainMultilineText' as const, key: '', content: '' };
    const emptyImage = { kind: 'image' as const, key: '', imageUrl: '' };

    return {
        pageTitle: emptyPlain,
        pageSubtitle: emptyMulti,
        pageTitleBackgroundImage: emptyImage,
        searchInputPlaceholder: emptyPlain,
    };
}
